<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Configurações' | translate}}</ion-title>

    <ion-col class="end-filter">
      <ion-list class="btn-idioma">
        <ion-select
          interface="action-sheet"
          value="{{MyDefaultYearIdValue}}"
          [compareWith]="compareWith"
          (ionChange)="changeIdioma($event)"
          style="min-height: 30px"
        >
          <ion-select-option *ngFor="let v of idiomaList" [value]="v.id">{{v.nome}} </ion-select-option>
        </ion-select>
      </ion-list>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content>
  <app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

  <div *ngIf="loaded">
    <div class="gradient-extendido"></div>

    <p *ngIf="configs.lgpd" class="lgpd">
      {{'Lei Geral de Proteção de dados registrado em ' | translate}}
      <strong>
        {{configs.lgpd.created_at | dateFormat:'ddmmyyyy'}} {{configs.lgpd.created_at | dateFormat:'hora'}} {{'IP' |
        translate}}{{configs.lgpd.ip}}
      </strong>
    </p>
  </div>

  <div *ngIf="loaded">
    <ion-card>
      <ion-grid>
        <ion-row *ngIf="meuCadastro">
          <ion-col size="12">
            <ion-list lines="full" (click)="documentos(pessoa.id)">
              <ion-item class="list-item">
                <ion-note slot="start">
                  <i class="fa fa-book"></i>
                </ion-note>

                <ion-label>
                  <h2 class="item-title">{{'Meus Documentos' | translate}}</h2>
                </ion-label>

                <i class="fa-regular fa-chevron-right icon-list"></i>
              </ion-item>
            </ion-list>
          </ion-col>

          <ion-col size="12" *ngIf="!userProvider.hasConfig(148)">
            <ion-list lines="full" (click)="carteirinhas()">
              <ion-item class="list-item">
                <ion-note slot="start">
                  <i class="fa-solid fa-address-card"></i>
                </ion-note>

                <ion-label>
                  <h2 class="item-title">{{'Minhas Carteirinhas' | translate}}</h2>
                </ion-label>

                <i class="fa-regular fa-chevron-right icon-list"></i>
              </ion-item>
            </ion-list>
          </ion-col>

          <ion-col size="12" *ngIf="!hasFacebook && (!esconderCadastro  && !esconderFacebook)">
            <ion-list lines="full" (click)="buscarDadosFacebook()">
              <ion-item class="list-item">
                <ion-note slot="start">
                  <i class="fa-brands fa-facebook"></i>
                </ion-note>

                <ion-label>
                  <h2 class="item-title">{{'Vincular Facebook' | translate}}</h2>
                </ion-label>

                <i class="fa-regular fa-chevron-right icon-list"></i>
              </ion-item>
            </ion-list>
          </ion-col>

          <ion-col size="12" *ngIf="hasFacebook && (!esconderCadastro  && !esconderFacebook)">
            <ion-list lines="full" (click)="desvincularFacebook()">
              <ion-item class="list-item">
                <ion-note slot="start">
                  <i class="fa-brands fa-facebook"></i>
                </ion-note>

                <ion-label>
                  <h2 class="item-title">{{'Desvincular Facebook' | translate}}</h2>
                </ion-label>

                <i class="fa-regular fa-chevron-right icon-list"></i>
              </ion-item>
            </ion-list>
          </ion-col>

          <ion-col size="12">
            <ion-list lines="full" (click)="alterarSenha()">
              <ion-item class="list-item">
                <ion-note slot="start">
                  <i class="fas fa-key"></i>
                </ion-note>

                <ion-label>
                  <h2 class="item-title">{{'Alterar Senha' | translate}}</h2>
                </ion-label>

                <i class="fa-regular fa-chevron-right icon-list"></i>
              </ion-item>
            </ion-list>
          </ion-col>

          <ion-col size="12" *ngIf="pessoaTipo">
            <ion-list
              lines="full"
              *ngIf="!userProvider.isAnonimo() && (userProvider.hasConfig(8) || userProvider.hasConfig(9) || 
            userProvider.hasConfig(10) || userProvider.hasConfig(11) || userProvider.hasConfig(26))"
            >
              <ion-item class="list-item" (click)="relatorios()">
                <ion-note slot="start">
                  <i class="fa-solid fa-clipboard-list"></i>
                </ion-note>

                <ion-label>
                  <h2 class="item-title">{{'Relatórios' | translate}}</h2>
                </ion-label>

                <i class="fa-regular fa-chevron-right icon-list"></i>
              </ion-item>
            </ion-list>
          </ion-col>

          <ion-col size="12">
            <ion-list lines="full" (click)="excluirCadastro();">
              <ion-item class="list-item">
                <ion-note slot="start">
                  <i class="fa-solid fa-circle-xmark"></i>
                </ion-note>

                <ion-label>
                  <h2 class="item-title">{{'Solicitação de exclusão' | translate}}</h2>
                </ion-label>

                <i class="fa-regular fa-chevron-right icon-list"></i>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card>

    <ion-card>
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-list class="switchers-list">
              <ion-item class="switcher-item">
                <ion-label class="bold-1 title">{{'PERMISSÕES' | translate}}</ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-list class="switchers-list">
              <ion-item class="switcher-item">
                <ion-toggle
                  [enableOnOffLabels]="true"
                  class="bold-1"
                  [ngModel]="configs.receberAniversario.status"
                  (ngModelChange)="setConfig(configs.receberAniversario)"
                >
                  {{'Notificação de Aniversário do Dia' | translate}}
                </ion-toggle>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-list class="switchers-list">
              <ion-item class="switcher-item">
                <ion-toggle
                  [enableOnOffLabels]="true"
                  class="bold-1"
                  [ngModel]="configs.divulgarAniversario.status"
                  (ngModelChange)="setConfig(configs.divulgarAniversario)"
                >
                  {{'Divulgar meu Aniversário' | translate}}
                </ion-toggle>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-list class="switchers-list">
              <ion-item class="switcher-item">
                <ion-toggle
                  [enableOnOffLabels]="true"
                  class="bold-1"
                  [ngModel]="configs.divulgarContato.status"
                  (ngModelChange)="setConfig(configs.divulgarContato)"
                >
                  {{'Divulgar Dados de Contato' | translate}}
                </ion-toggle>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-list class="switchers-list">
              <ion-item class="switcher-item">
                <ion-toggle
                  [enableOnOffLabels]="true"
                  class="bold-1"
                  [ngModel]="configs.profissaoportal.status"
                  (ngModelChange)="setConfig(configs.profissaoportal)"
                >
                  {{'Divulgar Dados Profissionais' | translate}}
                </ion-toggle>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <!-- <ion-row>
          <ion-col>
            <ion-list class="switchers-list">
              <ion-item class="switcher-item">
                <ion-toggle [enableOnOffLabels]="true" class="bold-1" (ionChange)="toggleTheme($event)"
                  [(ngModel)]="darkMode">
                  {{'Dark mode' | translate}}
                </ion-toggle>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-card>

    <ion-card>
      <ion-list class="switchers-list" (click)="politicas()">
        <ion-item class="switcher-item">
          <ion-label class="bold-1 title"> {{'POLÍTICAS DE USO' | translate}}</ion-label>
        </ion-item>
      </ion-list>
      <ion-list class="switchers-list" (click)="politicas()">
        <ion-item class="switcher-item">
          <ion-label class="bold-1"> {{'Políticas de Privacidade' | translate}}</ion-label>
          <i class="fa-regular fa-chevron-right icon-list"></i>
        </ion-item>
      </ion-list>
      <ion-list class="switchers-list" (click)="termos()">
        <ion-item class="switcher-item">
          <ion-label class="bold-1">{{'Termos de Uso' | translate}}</ion-label>
          <i class="fa-regular fa-chevron-right icon-list"></i>
        </ion-item>
      </ion-list>
    </ion-card>

    <p class="versao title">
      {{'Versão do Aplicativo' | translate}} - 18.4.0
    </p>
  </div>
</ion-content>
